(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ov-our-belief"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const link = event.target.closest('.ov-belief-r1-ref');
    if (!link) return;
    const note = link.closest('.ov-belief--r1').querySelector('.ov-belief-r1-research');
    if (note) note.open = true;
  });
  } catch(e) { console.error(e); }
})();

})();
